import { Table, Text } from "@chakra-ui/react";
import type { ComponentProps, ReactNode } from "react";

type ColumnHeaderProps = {
  children?: ReactNode;
} & Omit<ComponentProps<typeof Table.ColumnHeader>, "border" | "fontSize" | "fontWeight" | "color" | "p">;

const ColumnHeader = ({ children, ...rest }: ColumnHeaderProps) => (
  <Table.ColumnHeader
    border="none"
    fontSize="sm"
    fontWeight="semibold"
    color="text.secondary"
    p={3}
    {...rest}
  >
    {children}
  </Table.ColumnHeader>
);

interface EmptyRowProps {
  colSpan: number;
  children: ReactNode;
}

const EmptyRow = ({ colSpan, children }: EmptyRowProps) => (
  <Table.Row>
    <Table.Cell border="none" p={3} colSpan={colSpan}>
      <Text fontSize="sm" color="text.secondary">
        {children}
      </Text>
    </Table.Cell>
  </Table.Row>
);

export { ColumnHeader, EmptyRow };
